import {useRef} from "react";
import L from "leaflet";
import {useCRS} from "./CRSHook";

export const availableBaseLayers = [
    {
        code: "carto_osm",
        name: "Carto OSM",
        url: "https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png",
        useAppCRS: true,
        wmsOptions: {
            attribution:
                '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>',
            subdomains: "abcd",
            maxZoom: 20,
        },
    },
];

export function useBaseLayer() {
    let layerRef = useRef(null);
    const {crs} = useCRS();

    const setBaseLayer = (map, baseLayer) => {
        if (map) {
            if (layerRef.current) {
                map.removeLayer(layerRef.current);
            }
            if (baseLayer) {
                layerRef.current = L.tileLayer
                    .wms(baseLayer.url, {
                        ...baseLayer.wmsOptions,
                        crs: baseLayer.useAppCRS ? crs : null,
                    })
                    .addTo(map);
            }
        }
    };

    return {layerRef, setBaseLayer};
}
